import { LOGIST_ETRN_STATE_LABELS, type LogistEtrn } from '@entities/logistics';
import {
  Table,
  Th,
  Td,
  Badge,
  ErrorDetails,
  ActionRow,
  SmallBtn,
  EmptyState,
} from './styles';
import { stateTone } from './helpers';

interface LogistRegistryTableProps {
  registry: LogistEtrn[];
  tripName: (id: string) => string;
  can_write: boolean;
  enabled: boolean;
  explaining: boolean;
  titlesFor: string | null;
  onRefresh: (id: string) => void;
  onRevoke: (id: string) => void;
  onExplain: (id: string) => void;
  onToggleTitles: (id: string) => void;
}

export function LogistRegistryTable({
  registry,
  tripName,
  can_write,
  enabled,
  explaining,
  titlesFor,
  onRefresh,
  onRevoke,
  onExplain,
  onToggleTitles,
}: LogistRegistryTableProps) {
  if (registry.length === 0) {
    return <EmptyState>ЭТрН пока нет.</EmptyState>;
  }

  return (
    <Table>
      <thead>
        <tr>
          <Th>Рейс</Th>
          <Th>Оператор</Th>
          <Th>ID у оператора</Th>
          <Th>Титул</Th>
          <Th>Статус (наш)</Th>
          <Th>Юр-статус оператора</Th>
          <Th>Отправлен</Th>
          {can_write && <Th>Действия</Th>}
        </tr>
      </thead>
      <tbody>
        {registry.map((e: LogistEtrn) => (
          <tr key={e.id}>
            <Td>{tripName(e.trip_id)}</Td>
            <Td>{e.operator_kind}</Td>
            <Td>{e.external_id ?? '—'}</Td>
            <Td>{e.title_number ?? '—'}</Td>
            <Td>
              <Badge $tone={stateTone(e.state)}>{LOGIST_ETRN_STATE_LABELS[e.state]}</Badge>
              {e.state === 'error' && (
                <ErrorDetails>
                  {e.last_error ?? 'ошибка'}
                  {e.attempts > 0 && ` · попыток: ${e.attempts}`}
                </ErrorDetails>
              )}
            </Td>
            <Td>{e.operator_status ?? '—'}</Td>
            <Td>{e.submitted_at ? new Date(e.submitted_at).toLocaleString('ru-RU') : '—'}</Td>
            {can_write && (
              <Td>
                <ActionRow>
                  <SmallBtn
                    disabled={!enabled || !e.external_id}
                    onClick={() => onRefresh(e.id)}
                  >
                    Обновить статус
                  </SmallBtn>
                  <SmallBtn
                    disabled={!enabled || !e.external_id || e.state === 'revoked'}
                    onClick={() => onRevoke(e.id)}
                  >
                    Аннулировать
                  </SmallBtn>
                  <SmallBtn
                    disabled={explaining || (!e.last_error && !e.operator_status)}
                    onClick={() => onExplain(e.id)}
                  >
                    Объяснить
                  </SmallBtn>
                  <SmallBtn onClick={() => onToggleTitles(e.id)}>
                    {titlesFor === e.id ? 'Скрыть титулы' : 'Титулы'}
                  </SmallBtn>
                </ActionRow>
              </Td>
            )}
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
